import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { FormatNumberPipe } from '@app/shared/pipes/formatnumber.pipe';
import { strictDynamicFormControlCustomEvent } from '../../helpers/custom-event.helper';
import { parseStringTemplate } from '../../helpers/parse-string-template.helper';
import { CustomDynamicFormControlComponent } from '../custom-dynamic-form-control.component';
import { EVENT_TYPE_CHECKBOX_KONNEX, EVENT_TYPE_NAVIGATE, EVENT_TYPE_SCHADENNUMMER } from '../shared-models/custom-events.model';
import { AbschlussComponentModel } from './abschluss.model';

@Component({
  selector:    'gsm-abschluss',
  templateUrl: './abschluss.component.html',
  styleUrls:   ['./abschluss.component.scss'],
  standalone:  true,
  imports:     [
    NgIf,
    MatIconButton,
    MatIcon,
    MatCheckbox,
    MatFormField,
    MatLabel,
    MatSelect,
    FormsModule,
    NgFor,
    MatOption,
    FormatNumberPipe
  ]
})
export class AbschlussComponent extends CustomDynamicFormControlComponent<AbschlussComponentModel> implements OnInit {

  checked = false;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onChange() {
    this.change.emit(this.model.value);
  }

  protected onModelChange(): void {
    if (this.model.options.length === 1) {
      this.model.value = this.model.options[0].value;
    }
    if (this.model.contentValues?.schadennummer) {
      this.customEvent.emit(
        strictDynamicFormControlCustomEvent(EVENT_TYPE_SCHADENNUMMER, {
          detail: {schadennummer: this.model.contentValues.schadennummer}
        })
      );
    }
  }

  get content() {
    return parseStringTemplate(this.model.content, this.model.contentValues);
  }

  onIconClick() {
    this.customEvent.emit({
      customEvent:     new CustomEvent(EVENT_TYPE_NAVIGATE),
      customEventType: EVENT_TYPE_NAVIGATE
    });
  }

  onCheckboxClick() {
    this.checked = !this.checked;
    this.customEvent.emit(strictDynamicFormControlCustomEvent(EVENT_TYPE_CHECKBOX_KONNEX, {detail: this.checked}));
  }
}
